module.exports = __webpack_public_path__ + "img/home_decoration_hover.c9497bed.png";